export default __webpack_public_path__ + "static/pampas-4566c4663707dc472e4b2bd5c9f126a3.svg";